<template>
  <div class="collapsible-section" :class="{ 'has-error': hasError, 'is-collapsed': !isExpanded }">
    <div class="section-header" @click="toggle" :class="{ disabled: disabled }">
      <div class="header-left">
        <i v-if="icon" :class="icon" class="section-icon"></i>
        <h6 class="section-title">{{ title }}</h6>
        <span v-if="hasError && !isExpanded" class="error-indicator">
          <i class="fas fa-exclamation-circle"></i>
        </span>
      </div>
      <div class="header-right">
        <slot name="header-extra"></slot>
        <i class="fas toggle-icon" :class="isExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      </div>
    </div>
    <transition name="slide">
      <div v-show="isExpanded" class="section-content">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'CollapsibleSection',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: null
    },
    defaultExpanded: {
      type: Boolean,
      default: true
    },
    hasError: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isExpanded: this.defaultExpanded
    };
  },
  methods: {
    toggle() {
      if (!this.disabled) {
        this.isExpanded = !this.isExpanded;
        this.$emit('toggle', this.isExpanded);
      }
    },
    expand() {
      this.isExpanded = true;
    },
    collapse() {
      this.isExpanded = false;
    }
  }
};
</script>

<style scoped>
.collapsible-section {
  margin-bottom: 1rem;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.collapsible-section.has-error {
  border-color: #e74c3c;
}

.collapsible-section.is-collapsed {
  border-color: #dee2e6;
}

.collapsible-section.has-error.is-collapsed {
  border-color: #e74c3c;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background: #f8f9fa;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease;
}

.section-header:hover:not(.disabled) {
  background: #e9ecef;
}

.section-header.disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.section-icon {
  color: #3498db;
  font-size: 1rem;
}

.section-title {
  margin: 0;
  font-weight: 600;
  color: #2c3e50;
  font-size: 1rem;
}

.error-indicator {
  color: #e74c3c;
  margin-left: 0.5rem;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.toggle-icon {
  color: #6c757d;
  transition: transform 0.2s ease;
}

.section-content {
  padding: 1rem;
  border-top: 1px solid #dee2e6;
}

/* Slide transition */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
  max-height: 2000px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0;
}
</style>
